import { render, staticRenderFns } from "./ReviewsSlider.vue?vue&type=template&id=70bf794f"
import script from "./ReviewsSlider.vue?vue&type=script&lang=ts"
export * from "./ReviewsSlider.vue?vue&type=script&lang=ts"
import style0 from "./ReviewsSlider.vue?vue&type=style&index=0&id=70bf794f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports